import React from "react";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { camelize } from "humps";
/**
 * add account owner as employeeName to conform to pageFields[].format of "${ '@user.employeeName'}"
 *
 * @param  {Array}  accounts [description]
 * @param  {[type]} login    [description]
 * @return {[type]}          [description]
 */
export const enrichAccounts = (accounts = [], login) =>
  accounts.map(account => ({
    ...account,
    user: {
      employeeName: account.owner || login.user.employee.fullName,
    },
  }));

export const renderRejectedFiles = files =>
  files && files.length ? (
    <div className="field__error">
      <FormattedMessage {...messages.uploadImageLimitationDescription} />
    </div>
  ) : null;

const _TYPES = {
  CURRENCY: "Currency",
  DATE: "Date",
  LINK: "Link",
};
export const TYPES = {
  ..._TYPES,
  isDate: v => camelize(v) === _TYPES.DATE,
  isLink: v => camelize(v) === _TYPES.LINK,
};



// WEBPACK FOOTER //
// ./components/inAppMessages/helper.js